const RICH_TAGS = new Set([
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "s",
  "strike",
  "span",
  "a",
]);

function escapeAttr(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;");
}

function safeRichUrl(value) {
  const url = String(value || "").trim();
  if (!url || /[\s<>"]/.test(url)) return "";
  if (url.startsWith("/") || url.startsWith("#")) return url;
  if (/^(https?:|mailto:|tel:)/i.test(url)) return url;
  return "";
}

export function sanitizeRichText(value) {
  const raw = String(value || "").replace(/\u0000/g, "").trim();
  if (!raw || !/<[a-z!/]/i.test(raw)) return raw;

  let source = raw
    .replace(/<!--[\s\S]*?-->/g, "")
    .replace(/<(script|style|iframe|object|embed|svg|math)\b[^>]*>[\s\S]*?<\/\1>/gi, "");

  source = source.replace(/<\/?([a-z0-9]+)(\s[^<>]*)?>/gi, (match, tag, attrs = "") => {
    const name = tag.toLowerCase();
    if (!RICH_TAGS.has(name)) return "";
    if (match.startsWith("</")) return name === "br" ? "" : `</${name}>`;
    if (name === "br") return "<br>";
    if (name === "span") {
      const style = String(attrs).match(/style\s*=\s*(?:"([^"]*)"|'([^']*)')/i);
      const color = style && `${style[1] || style[2] || ""}`.match(/color\s*:\s*(#[0-9a-f]{3,8})\b/i);
      return color ? `<span style="color:${color[1]}">` : "<span>";
    }
    if (name === "a") {
      const href = String(attrs).match(/href\s*=\s*(?:"([^"]*)"|'([^']*)')/i);
      const url = safeRichUrl(href && (href[1] || href[2]));
      return url
        ? `<a href="${escapeAttr(url)}" rel="noopener noreferrer" target="_blank">`
        : "<a>";
    }
    return `<${name}>`;
  });

  source = source.replace(/<a>([\s\S]*?)<\/a>/gi, "$1");
  return source.replace(/<([a-z]+)>\s*<\/\1>/gi, "").trim();
}

export function hasRichMarkup(value) {
  return /<[a-z]/i.test(String(value || ""));
}
